
import "./input-v1"
import "./checkout-tos-v1"
import "./checkout-multi-step-v2"
import "./checkout-order-summary-v1"
import "./checkout-product-select-v2"
import "./checkout-product-select-bump-v2"
import "./checkout-shipping-profile-select-v1"
import "./checkout-loading-v1"
import "./checkout-submit-button-v1"
import "./checkout-configuration-error-v1"
import "./checkout-order-details-v1"
import { StripeCheckoutLogic, createInstance } from '@yggdrasil/Checkout/V2/StripeCheckout/stripeCheckout'
import { ensureStripeScriptLoaded } from '@yggdrasil/Checkout/V2/StripeCheckout/stripe'
import { ensureCheckoutStoreInitialized } from '@yggdrasil/Checkout/V2/StripeCheckout/store'
import { CF2Component, registerComponent } from 'javascript/lander/runtime'

export default class StripeCheckout extends CF2Component {

constructor(el, runtimeSel) {
super(el, runtimeSel)
}





    checkout: StripeCheckoutLogic
    _lazyInitPending: boolean

    _doInitialize() {
      this.checkout = createInstance(this)
    }

    _doMount() {
      this.checkout.mount()
    }

    initialize() {
      if (this.lazyLoadCheckout) {
        this._lazyInitPending = true
        ensureCheckoutStoreInitialized()
        return
      }
      this._doInitialize()
    }

    mount() {
      if (this._lazyInitPending) {
        return
      }
      this._doMount()
    }

    async _performLazyInit() {
      this._lazyInitPending = false
      await ensureStripeScriptLoaded()
      this._doInitialize()
      this._doMount()
    }

    getCart() {
      return this.checkout.store.checkoutCart.get()
    }

    async submitOTO(redirectOverride) {
      const ok = await this.checkout.submitCheckout(redirectOverride)
      const failure = this.checkout.lastSubmitFailure
      return { ok, actionable: failure ? failure.actionable : true, message: failure && failure.message }
    }



}

registerComponent('StripeCheckout', StripeCheckout)
window["StripeCheckout"] = StripeCheckout

